import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import { orgLd, serviceLd, faqLd } from "../seo/jsonld";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ConsentBanner from "../components/ConsentBanner";
import RoiCalculator from "../components/RoiCalculator";
import QualificationForm from "../components/QualificationForm";
import {
  Hero, BrandMarquee, Credibility, Problem, TimeSaved, PacteLoop, Pricing, Proof,
  Competitive, Guarantee, Founders, TransparencyMatrix, AnglesOverview, Faq, FinalCta, Personas,
} from "../components/blocks";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location]);

  return (
    <div>
      <Seo
        routeKey="/"
        jsonLd={[orgLd, serviceLd, faqLd]}
      />
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <Personas />
        <Credibility />
        <Problem />
        <TimeSaved />
        <PacteLoop />
        <Pricing />
        <Proof />
        <Competitive />
        <Guarantee />
        <RoiCalculator />
        <AnglesOverview />
        <Founders />
        <TransparencyMatrix />
        <Faq />
        <QualificationForm />
        <FinalCta />
      </main>
      <Footer />
      <ConsentBanner />
    </div>
  );
}
